import { Injectable } from "@angular/core";
import { ToastrService, IndividualConfig } from "ngx-toastr";

@Injectable({
  providedIn: "root",
})
export class ToastService {
  constructor(private toastr: ToastrService) {}

  success(message: string, title?: string, duration?: number) {
    this.toastr.success(message, title, this.getConfig(duration));
  }

  error(message: string, title?: string, duration?: number) {
    this.toastr.error(message, title, this.getConfig(duration));
  }

  warning(message: string, title?: string, duration?: number) {
    this.toastr.warning(message, title, this.getConfig(duration));
  }

  info(message: string, title?: string, duration?: number) {
    this.toastr.info(message, title, this.getConfig(duration));
  }

  private getConfig(duration?: number): Partial<IndividualConfig> | undefined {
    return duration ? { timeOut: duration } : undefined;
  }
}
